import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TPVServices } from '../../../tpv/services';
import { TakeawayServices } from '../../../takeaway/services';

/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tips',
  templateUrl: 'tips.html',
})
export class TipsPage {
  origin: 'tpv';
  percentage: 0;
  total = 0;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public globals: Globals,
    public tpvServices: TPVServices,
    public takeawayServices: TakeawayServices) {
    this.origin = this.navParams.get('origin');
  }

  close() {
    this.viewCtrl.dismiss();
  }

  applyPercentage(tip) {
    this.percentage = tip;
    this.calculateTip();
  }

  onchangePercentage() {
    this.calculateTip();
  }

  calculateTip() {
    var _total = 0;
    if (this.origin == 'tpv') {
      _total = this.tpvServices.totalTicketSelected(this.tpvServices.selected_table_tpv_index);
      this.total = Math.round(((_total * this.percentage) / 100 + Number.EPSILON) * 100) / 100;
    } else {
      _total = this.takeawayServices.totalTicketSelected(this.takeawayServices.selected_table_tpv_index);
      this.total = Math.round(((_total * this.percentage) / 100 + Number.EPSILON) * 100) / 100;
    }
  }

  applyTip() {
    var uid = '';
    if (this.origin == 'tpv') {
      this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.tip = this.total;
      uid = this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].UID;

      this.tpvServices.afs.collection('tables').doc(uid).update({
        ticket: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket,
      }).then(doc => {
        this.viewCtrl.dismiss();
      });
    } else {
      this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.tip = this.total;
      uid = this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID;

      this.takeawayServices.afs.collection('tables').doc(uid).update({
        ticket: this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket,
      }).then(doc => {
        this.viewCtrl.dismiss();
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/components/popups/tips/tips.ts